import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20music%20performance%20scene%20with%20dramatic%20red%20and%20black%20color%20palette%2C%20stage%20lighting%20with%20warm%20spotlights%2C%20silhouette%20of%20a%20musician%20on%20stage%2C%20atmospheric%20smoke%2C%20elegant%20and%20powerful%20concert%20vibe%2C%20high%20contrast%2C%20editorial%20photography%2C%20emotional%20and%20grandiose%2C%20no%20text%20or%20logos%2C%20abstract%20artistic%20composition&width=1920&height=1080&seq=soniem-hero-bg-01&orientation=landscape"
          alt="SONIEM - Escenario musical artístico"
          className="w-full h-full object-cover object-center"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/60 to-black/80" />
        {/* Red tint accent */}
        <div className="absolute inset-0 bg-primary-900/20 mix-blend-multiply" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6 md:mb-8">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse" />
            <span className="text-white/90 text-xs md:text-sm font-medium tracking-wide uppercase">
              Autorizado por Indecopi - Resolución Nº 0054-2011/DDA
            </span>
          </div>

          {/* Main Title */}
          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4 md:mb-6">
            Protegemos los derechos de los{' '}
            <span className="text-primary-400">artistas musicales</span>{' '}
            del Perú
          </h1>

          {/* Subtitle */}
          <p className="text-white/70 text-base md:text-lg lg:text-xl max-w-2xl mb-8 md:mb-10 leading-relaxed">
            Somos la Sociedad Nacional de Intérpretes y Ejecutantes de la Música. 
            Gestionamos y distribuimos regalías para más de 3,300 artistas afiliados 
            a nivel nacional e internacional.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contacto"
              className="group inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              <span>Afíliate a SONIEM</span>
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link
              to="/nosotros"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-white/10 text-white font-semibold text-sm md:text-base border border-white/20 hover:bg-white/20 backdrop-blur-sm transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-lg" />
              <span>Conoce más</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom brand text */}
      <div className="absolute bottom-0 left-0 right-0 pb-8 md:pb-12">
        <div className="px-4 md:px-6 lg:px-10">
          <p className="font-heading text-white/10 text-[10vw] md:text-8xl lg:text-9xl font-black leading-none select-none tracking-tighter">
            SONIEM
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2">
          <span className="text-white/50 text-xs font-medium tracking-widest uppercase">Descubre</span>
          <div className="w-5 h-8 rounded-full border-2 border-white/30 flex items-start justify-center p-1">
            <div className="w-1 h-2 rounded-full bg-white/60 animate-bounce" />
          </div>
        </div>
      </div>
    </section>
  );
}